import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import ClassChangePage from './View/Page/ClassChangePage';
import DungeonPage from './View/Page/DungeonPage';
import LandingPage from './View/Page/LandingPage';
import PersonalityPage from './View/Page/PersonalityPage';
import Header from './View/Component/Header/Header';
import Swal from 'sweetalert2';

const announceHTML = `<div class="announce">
  해당 사이트는 더 이상 업데이트가 진행되지 않습니다.
  <br/>
  This site will not be updated from now.
  <br/><br/>
  <a href="https://aecheck.com/" target="_blank" rel="noreferrer"><b>Please use Checklist Site instead.</b></a>
  <br/>
  <br/>
  자세한 사항은 링크를 확인해 주세요.<br/>
  Please Check following link.
  <br/><br/>
  <a href="https://aecheck.tistory.com/notice/10" target="_blank" rel="noreferrer">Announcement</a>
</div>`

function App() {

  useEffect(() => {
    Swal.fire({
      title: 'Update Stopped',
      html: announceHTML,
      icon: 'error',
    })
  }, [])

  return (
    <Router basename="/anotherdungeon">
        <Header />
        <Route exact path="/" component={LandingPage}/>
        <Route exact path="/dungeon" component={() => <Redirect to="/dungeon/ancient_miglania_swamp"/>}/>
        <Route exact path="/dungeon/:name" component={DungeonPage}/>
        <Route exact path="/class" component={ClassChangePage}/>
        <Route exact path="/personality" component={PersonalityPage}/>
        <footer style={{margin: "1rem auto", marginTop: '50px', textAlign: 'center',
                minWidth: '250px', maxWidth: '400px'}}>
            &copy; 2021. Made By <a href="https://github.com/HU-Lee" target="_blank" rel="noreferrer">HU-Lee</a>
        </footer>
    </Router>  
  );
}

export default App;
